import React, { useState } from "react";

const ViewRejectModal = ({ visits, closeModal }) => {
  console.log("visits : ", visits);
  const [note, setNote] = useState(null);
  return (
    <div className="modal">
      <div className="modal-overlay">
        <div className="modal-container w-4/12 mt-2">
          <div className="modal-header items-center justify-between flex gap-3">
            <h3 onClick={closeModal} className="cursor-pointer">
              X
            </h3>
            <div>
              <select
                name=""
                onChange={(e) => setNote(e.target.value)}
                className="input w-full"
                id=""
              >
                <option value="-1">Select Visit</option>
                {visits?.map((visit, index) => {
                  return (
                    <option key={index} value={visit.rejects.note}>
                      {visit?.created_at?.split("T")[0]}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          {note == null || note == -1 ? (
            ""
          ) : (
            <form action="">
              <textarea
                name=""
                className="input w-full"
                readOnly
                value={note}
                id=""
              ></textarea>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewRejectModal;
